export default __webpack_public_path__ + "static/media/Amit_Prasad.1a4baf03.jpg";